<template>
  <v-chip label v-if="loading"
          color="yellow lighten-4"
          class="bottom-center saving">{{title}}&nbsp;<span>.</span><span>.</span><span>.</span></v-chip>

</template>

<script>
export default {
  name: 'ThreeDots',
  props: {
    loading: {type: Boolean, default: false},
    title: {type: String, default: 'loading'}
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .bottom-center{
    position: fixed;
    bottom: 10px;
    text-align: right;
    right: 10px;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #ffeb3b;
    border-radius: 2px;
  }
  @keyframes blink {
    /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
    0% {
      opacity: .2;
    }
    /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
    20% {
      opacity: 1;
    }
    /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
    100% {
      opacity: .2;
    }
  }

  .saving span {
    font-size: 30px;
    padding-bottom: 10px;
    /**
     * Use the blink animation, which is defined above
     */
    animation-name: blink;
    /**
     * The animation should take 1.4 seconds
     */
    animation-duration: 1.4s;
    /**
     * It will repeat itself forever
     */
    animation-iteration-count: infinite;
    /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */
    animation-fill-mode: both;
  }

  .saving span:nth-child(2) {
    /**
     * Starts the animation of the third dot
     * with a delay of .2s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: .2s;
  }

  .saving span:nth-child(3) {
    /**
     * Starts the animation of the third dot
     * with a delay of .4s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: .4s;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/widgets/ThreeDots.vue